import {
    createRegisterableComponent,
} from '@news-mono/web-common'
import React from 'react'
import { BreachWallContentType } from './helpers/BreachWallTypes'
import { BreachWallContentWrapper } from './components/BreachWallContent/BreachWallContentWrapper'

export interface BreachScreenRegistrationProps {
    bannerMessage?: string
    breachCreativeName: string
    breachDeal: string
    breachType: BreachWallContentType
    title: string
    message?: string
    terms: string
}

export const BreachScreenRegistration = createRegisterableComponent(
    'breachscreen',
    (props: BreachScreenRegistrationProps, services) => {
        return (
            <BreachWallContentWrapper
                suppliedDeal={props.breachDeal}
                suppliedType={props.breachType}
                suppliedCreative={props.breachCreativeName}
                requiredAccess={'subscriber'}
                location={services.location}
                onEvent={services.onEvent}
                bannerSize={'large'}
                bannerText={props.bannerMessage}
                title={props.title}
                message={props.message}
                terms={props.terms}
                log={services.log}
            />
        )
    },
)

function breachDealTerms(deal: string) {
    switch (deal) {
        case 'SCHOOL30':
            return 'Offer ends 23 November 2021.'
        case 'BIKEDI30':
            return 'Offer ends 21 November 2021.'
        case 'GOVAN50':
            return 'Offer ends 20 February 2021.'
        case 'BRE1DISC':
            return 'Offer ends 2 May 2021.'
        default:
            return ''
    }
}
